// extracted by mini-css-extract-plugin
export default {"dragenter":"style-module_dragenter_DbYTNx"};